import React from 'react';
import { withRouter } from 'react-router-dom';
import { Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import styles from './preview.module.less';
import { getBroadcast } from '../../service/chat-service';
import WSK from './lys.websocket';

const propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

class OrderDetail extends React.Component {
  ws = null;

  constructor(props) {
    super(props);
    this.state = {
      ulist: [],
      images: '',
      // isSHOW: '',
      broType: null,
      messageLits: [],
    };

    this.fieldName = {};
  }

  componentDidMount() {
    const { location } = this.props;
    document.title = '订单详情';
    const broadcastId = location.search.split('=')[1];
    getBroadcast(broadcastId).then((res) => {
      let arr = [];
      if (res.code === 10000) {
        document.title = res.data.title ? res.data.title : '订单详情';

        const broType = res.data.type;

        if (broType !== 2) {
          const messageLits = [];
          res.data.list.forEach((item) => {
            messageLits.unshift(item);
          });

          this.fieldName = res.data.fieldName;

          return this.setState({ broType, messageLits, images: res.data.img });
        }

        const dList = [];
        let name = '';
        // 倒序
        res.data.list.forEach((item) => {
          dList.unshift(item);
        });
        arr = dList.map((item1) => {
          const item = item1;
          item.orderAmount /= 100;
          item.userCellphone = item1.userCellphone;
          name = '';
          if (item.freeProperties) {
            name = JSON.parse(item.freeProperties).customerName
              ? JSON.parse(item.freeProperties).customerName
              : '';
          }
          if (name && name.length < 2) {
            item.customerName = name;
          } else if (name && name.length === 2) {
            item.customerName = `${name[0]} *`;
          } else if (name && name.length === 3) {
            item.customerName = `${name[0]} * ${name[name.length - 1]}`;
          } else if (name && name.length >= 4) {
            item.customerName = `${name[0]} * *${name[3]}`;
          }
          return item;
        });
        this.setState({
          images: res.data.img,
          ulist: arr,
          broType,
        });
      } else {
        Toast.fail(res.message, 1);
      }
      return true;
    });
    this.wskt();
  }

  wskt() {
    const that = this;
    const { location } = this.props;
    const a = location.search.split('=')[1];
    const url = `wss://letssell.yunkecn.com/ws?${a}`;
    this.socket = WSK.call(window, {
      host: url,
      name: '',
    });
    this.socket.onopen(() => {
      // console.log('成功握手');
    });
    this.socket.onmessage((msg) => {
      const { broType } = that.state;
      let { messageLits } = that.state;

      if (broType !== 2) {
        const message = JSON.parse(msg);
        messageLits.unshift(message);

        if (messageLits.length > 100) messageLits = messageLits.slice(0, 100);
        return that.setState({ messageLits });
      }

      const obj = {};
      const { ulist } = that.state;
      let { isSHOW } = that.state;
      const oo = JSON.parse(msg);
      obj.orderAmount = oo.orderAmount / 100; // 金额
      obj.userCellphone = oo.userCellphone; // 电话
      if (oo.freeProperties) {
        const o = JSON.parse(oo.freeProperties);
        if (o.customerName) {
          if (o.customerName.length < 2) {
            obj.customerName = o.customerName;
          } else if (o.customerName.length === 2) {
            obj.customerName = `${o.customerName[0]} *`;
          } else if (o.customerName.length === 3) {
            obj.customerName = `${o.customerName[0]
            } * ${
              o.customerName[o.customerName.length - 1]}`;
          } else if (o.customerName.length >= 4) {
            obj.customerName = `${o.customerName[0]} * *${o.customerName[3]}`;
          }
        } else {
          // 没有姓名为空
          obj.customerName = '';
        }
      } else {
        // 没有姓名为空
        obj.customerName = '';
      }
      if (ulist.length === 15) {
        ulist.shift(); // console.log(ulist,"删除")
      }
      isSHOW = obj;
      Toast.info(
        `${obj.customerName} ${obj.userCellphone} 已支付 ${obj.orderAmount}元`,
        1,
      );
      ulist.push(obj); // console.log(ulist,"添加")
      that.setState({
        ulist,
        isSHOW,
      });
      return true;
    });
    this.socket.onclose(() => {
      // console.log('连接断开');
    });
    this.socket.start();
  }

  render() {
    const {
      broType, images, ulist, messageLits,
    } = this.state;
    return (
      <div className={styles.preview}>
        <img className={styles.img} src={images} alt="preview" />
        {broType === 2 ? (
          <div className={styles.posi}>
            <ul>
              {ulist.map((item) => (
                <li key={item.key}>
                  <span>{item.customerName}</span>
                  {' '}
                  <span>{item.userCellphone}</span>
                  {' '}
                  <span>已支付</span>
                  {' '}
                  <span>
                    {item.orderAmount}
                    元
                  </span>
                  {' '}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className={styles.posi}>
            <ul>
              <li key="header">
                {Object.values(this.fieldName).map((value) => (
                  <span key={value}>
                    {value}
                    {' '}
                  </span>
                ))}
              </li>

              {messageLits.map((item) => {
                const keys = Object.keys(this.fieldName);
                return (
                  <li key={item.key}>
                    {keys.map((key) => (
                      <span key={key}>
                        {item[key]}
                        {' '}
                      </span>
                    ))}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

OrderDetail.propTypes = propTypes;

export default withRouter(OrderDetail);
